import { useEffect, useState } from "react";
import { cn } from "../../../lib/utils";

interface TypingIndicatorProps {
  isVisible: boolean;
  userName?: string | null;
  className?: string;
}

export function TypingIndicator({
  isVisible,
  userName,
  className,
}: TypingIndicatorProps) {
  const [dotIndex, setDotIndex] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    const interval = setInterval(() => {
      setDotIndex((prev) => (prev + 1) % 3);
    }, 500);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className={cn("flex items-center gap-2 p-3", className)}>
      <div className="flex items-center gap-1">
        <div
          className={cn(
            "w-2 h-2 rounded-full bg-gray-400 transition-all duration-300",
            dotIndex === 0 && "bg-gray-600 scale-110"
          )}
        />
        <div
          className={cn(
            "w-2 h-2 rounded-full bg-gray-400 transition-all duration-300",
            dotIndex === 1 && "bg-gray-600 scale-110"
          )}
        />
        <div
          className={cn(
            "w-2 h-2 rounded-full bg-gray-400 transition-all duration-300",
            dotIndex === 2 && "bg-gray-600 scale-110"
          )}
        />
      </div>
      <span className="text-sm text-gray-500">
        {userName ? `${userName} is typing...` : "Someone is typing..."}
      </span>
    </div>
  );
}
